import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {takeUntil} from 'rxjs/operators';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {Meeting} from '../../../shared/interface/meeting';
import {MeetingService} from '../../../shared/services/meeting.service';
import {
  MEETING_TYPE_EXAM,
  MEETING_TYPE_IDD_TRAINING,
  MEETING_TYPE_NEW_AGENT_TRAINING,
  MEETING_TYPE_ENTRANCE_EXAM
} from '../../../shared/services/dict.service';
import moment from 'moment';
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {Profile} from "../../../shared/interface/profile";

@Component({
  selector: 'app-meeting-details-view',
  templateUrl: './meeting-details-view.component.html',
  styleUrls: ['./meeting-details-view.component.scss']
})
export class MeetingDetailsViewComponent implements OnInit, OnDestroy {
  @Input() meeting: Observable<Meeting>;
  @Output() modifyClicked = new EventEmitter<any>();

  readonly MEETING_TYPE_IDD_TRAINING = MEETING_TYPE_IDD_TRAINING;
  readonly MEETING_TYPE_EXAM = MEETING_TYPE_EXAM;
  readonly MEETING_TYPE_NEW_AGENT_TRAINING = MEETING_TYPE_NEW_AGENT_TRAINING;
  readonly MEETING_TYPE_ENTRANCE_EXAM = MEETING_TYPE_ENTRANCE_EXAM;


  userPermissions: ReplaySubject<UserPermissions>;
  meetingObject?: Meeting;
  meetingMinutes: number = null;
  meetingHours: number = null;
  userProfile: Profile = null;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private meetingService: MeetingService,
    private snack: MatSnackBar,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.userProfile = profile;
      });
  }

  ngOnInit(): void {
    this.meeting
      .pipe(takeUntil(this.destroyed$))
      .subscribe((meeting: Meeting) => {
        this.meetingObject = meeting;
        const startsAt = moment(meeting.startsAt);
        const endsAt = moment(meeting.endsAt);
        const minutes = endsAt.diff(startsAt, 'minutes');

        this.meetingHours = Math.floor(minutes / 60);
        this.meetingMinutes = minutes % 60;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć to wydarzenie?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.meetingService.delete(this.meetingObject.uuid)
          .subscribe( {
            next: () => {
            this.snack.open('Pomyślnie usunięto', '', {duration: 2000});
              if (  window.location.href.includes('egzaminy-szkolenia') ){
                this.router.navigate(['/egzaminy-szkolenia']);
              }else {
                this.router.navigate(['/szkolenie']);
              }
            },
            error: (error: HttpErrorResponse) => {
              if (error.error?.error?.text) {
                this.snack.open(error.error.error.text, '400', { duration: 4000 });
              } else {
                this.snack.open('Nie można usunąć wydarzenia', error.status.toString(), {
                  duration: 2000,
                });
              }
        }
          });
      }
    });
  }

  downloadFile(uuid: string): void {
    this.meetingService.downloadFile(uuid);
  }

  downloadReport(): void {
    this.meetingService.downloadMeetingReport(this.meetingObject.uuid,{
      sortOrder: 'desc'
    })     .subscribe((response: Uuid) => {
      this.dialog.open(JobResultDialogComponent, {
        disableClose: true,
        width: '500px',
        data: {jobId: response.uuid, showProgress: false},
      });
    }, (error: HttpErrorResponse) => {
      this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
    });
  }
}
